<script lang="ts">
    import { _ } from "svelte-i18n"
    import { checkoutData, getAsyncCartSum } from "../../../functionTools/cart"

    import { login } from "../../../functionTools/login"
    import { formatPriceCurrency, langField } from "../../../i18n"
    import { getCountry } from "../../../api"

    interface Props {
        cartItems: CartItem[]
    }

    let { cartItems }: Props = $props()

    let cartSum: CartSum = $state()
    $effect(() => {
        ;(async () => {
            cartSum = await getAsyncCartSum(cartItems)
        })()
    })
</script>

{#if cartSum}
    <div class="result">
        <section>
            <div class="sum1">
                <div class="title">{$_("cart.subtotal")}</div>
                <div class="value">
                    {$formatPriceCurrency(cartSum.subtotalGross)}
                </div>
            </div>
        </section>
        {#if cartSum.minQtyGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        {$_("cart.shipping-costs")}
                        <div class="small">
                            {$_("cart.less-30eur-order-value")}
                        </div>
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.minQtyGross)}
                    </div>
                </div>
            </section>
        {/if}
        {#if cartSum.packagingGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        {$_("cart.packaging")}
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.packagingGross)}
                    </div>
                </div>
            </section>
        {/if}
        {#if cartSum.shippingGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        {$_("cart.shipping")}
                        {#if !$login}
                            {#await getCountry($checkoutData.deliveryAddress.countryCode) then country}
                                <div class="small">
                                    {langField(country.name, "")}
                                </div>
                            {/await}
                        {/if}
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.shippingGross)}
                    </div>
                </div>
            </section>
        {/if}
        <section>
            <div class="sum2">
                <div class="title">
                    {$_("cart.total")}
                    <div class="small">
                        {#if $login}
                            {$_("cart.without-vat-short")}
                        {:else}
                            {$_("cart.with-percent-vat-short", {
                                values: { percent: $checkoutData.vat },
                            })}
                        {/if}
                    </div>
                </div>
                <div class="value">
                    {$formatPriceCurrency(cartSum.totalGross)}
                </div>
            </div>
        </section>
    </div>
{/if}

<style lang="less">
    @import "../../../css/variables.less";

    .result {
        > section > div {
            .flex();
            justify-content: space-between;
        }
        section {
            border-bottom: dotted 1px #ccc;
            padding-bottom: 10px;
            margin-bottom: 10px;
            .sum1 .value {
                font-weight: 700;
            }
            .small {
                font-size: 0.7rem;
            }
            .sum2 .value {
                font-weight: 700;
                font-size: 1.2rem;
                color: var(--primary);
                @media @desktop {
                    font-size: 1.4rem;
                }
            }
        }
    }
</style>
